export const THEMES = {
  LIGHT: 'LIGHT',
  DARK: 'DARK',
  NATURE: 'NATURE'
};

export const siteOptions = 'siteOptions';

export const sitePagingOptions = 'sitePagingOptions';

export const draftOptions = 'draftOptions';

export const siteOptionKeys = {
  doNotShowSupplierInviteDialog: 'doNotShowSupplierInviteDialog',
  doNotShowActivityAreaWarning: 'doNotShowActivityAreaWarning',
  doNotShowOrderInstructions: 'doNotShowOrderInstructions',
  doNotShowOrderOptionsInstructions: 'doNotShowOrderOptionsInstructions',
  doNotShowFavoritePageWarning: 'doNotShowFavoritePageWarning',
  doNotShowBidRequestWaiting: 'doNotShowBidRequestWaiting',
  doNotShowWarninDialog: 'false',
  doNotShowDraftNameForExcel: 'doNotShowDraftNameForExcel',
  doNotShowSubAccountInformation: 'doNotShowSubAccountInformation',
  doNotShowSmsWarningDialog: 'doNotShowSmsWarningDialog',
};
